import { Plus, X } from "@phosphor-icons/react";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Icon, AGENT_ICONS, COLORS } from "@/lib/icons";

export const Section = ({ title, desc, children, id }) => (
  <section className="border-b border-white/10 px-6 py-8 lg:px-10" data-testid={`builder-section-${id}`}>
    <h2 className="font-display text-xl font-bold tracking-tight">{title}</h2>
    {desc && <p className="mt-1 text-sm text-zinc-500">{desc}</p>}
    <div className="mt-6 space-y-5">{children}</div>
  </section>
);

export const IdentitySection = ({ form, set, meta }) => (
  <Section id="identity" title="Identidad" desc="Cómo se presenta tu agente ante los usuarios y en el marketplace.">
    <div className="grid gap-5 md:grid-cols-2">
      <div><label className="label">Nombre</label><input value={form.name} onChange={(e) => set("name", e.target.value)} maxLength={80} className="field" data-testid="builder-name-input" /></div>
      <div>
        <label className="label">Categoría</label>
        <Select value={form.category} onValueChange={(v) => set("category", v)}>
          <SelectTrigger className="h-[42px] rounded-sm border-white/10 bg-[#0d0d0d]" data-testid="builder-category-select"><SelectValue /></SelectTrigger>
          <SelectContent className="border-white/10 bg-[#121212] text-white">{meta.categories.map((c) => <SelectItem key={c} value={c}>{c}</SelectItem>)}</SelectContent>
        </Select>
      </div>
    </div>
    <div><label className="label">Propuesta de valor</label><input value={form.tagline} onChange={(e) => set("tagline", e.target.value)} maxLength={160} className="field" placeholder="Una frase que explique qué resuelve" data-testid="builder-tagline-input" /></div>
    <div><label className="label">Descripción comercial</label><textarea value={form.description} onChange={(e) => set("description", e.target.value)} rows={4} maxLength={4000} className="field" placeholder="Qué hace, para quién es y por qué es diferente." data-testid="builder-description-input" /></div>
    <div className="grid gap-5 md:grid-cols-2">
      <div>
        <label className="label">Icono</label>
        <div className="flex flex-wrap gap-1">
          {AGENT_ICONS.map((n) => (
            <button key={n} onClick={() => set("icon", n)} className={`grid h-9 w-9 place-items-center border ${form.icon === n ? "border-blue-500 bg-blue-600/20 text-white" : "border-white/10 text-zinc-500 hover:text-white"}`} data-testid={`builder-icon-${n}`} style={{ transition: "color 160ms" }}><Icon name={n} size={16} /></button>
          ))}
        </div>
      </div>
      <div>
        <label className="label">Color</label>
        <div className="flex flex-wrap gap-2">
          {COLORS.map((c) => (
            <button key={c} onClick={() => set("color", c)} className={`h-9 w-9 border-2 ${form.color === c ? "border-white" : "border-transparent"}`} style={{ background: c }} data-testid={`builder-color-${c.slice(1)}`} />
          ))}
        </div>
      </div>
    </div>
    <div>
      <label className="label">Preguntas sugeridas ({form.conversation_starters.length}/6)</label>
      <div className="space-y-2">
        {form.conversation_starters.map((s, i) => (
          <div key={i} className="flex gap-2">
            <input value={s} onChange={(e) => set("conversation_starters", form.conversation_starters.map((x, j) => (j === i ? e.target.value : x)))} className="field" data-testid={`builder-starter-${i}`} />
            <button onClick={() => set("conversation_starters", form.conversation_starters.filter((_, j) => j !== i))} className="btn-ghost !px-3" data-testid={`builder-starter-remove-${i}`}><X size={14} /></button>
          </div>
        ))}
        {form.conversation_starters.length < 6 && (
          <button onClick={() => set("conversation_starters", [...form.conversation_starters, ""])} className="inline-flex items-center gap-1 text-sm text-blue-400 hover:text-blue-300" data-testid="builder-starter-add"><Plus size={14} /> Añadir pregunta</button>
        )}
      </div>
    </div>
  </Section>
);
